// components/HeroSection.tsx
"use client";

import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import HexLive from "@/components/HexLive";

interface HeroSectionProps {
  onLogin: () => void;
  isAuthenticated: boolean;
  onGoToApp: () => void;
}

export default function HeroSection({ onLogin, isAuthenticated, onGoToApp }: HeroSectionProps) {
  const t = useTranslations("hero");

  return (
        <section className="relative flex items-center min-h-screen bg-base pt-28 pb-12 px-6 md:px-12 lg:px-20 overflow-hidden">
      {/* Decorative grid */}
      <div
        className="pointer-events-none absolute inset-0 "
         style={{
          backgroundImage: `
            linear-gradient(rgb(var(--accent) / 0.25) 1px, transparent 1px),
            linear-gradient(90deg, rgb(var(--accent) / 0.25) 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
          maskImage: "radial-gradient(ellipse 100% 90% at 50% 50%, black, transparent 95%)",
          WebkitMaskImage: "radial-gradient(ellipse 100% 90% at 50% 50%, black, transparent 95%)",
        }}
      />

      {/* Radial glow */}
      {/* Radial glow */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 40% at 30% 50%, rgb(var(--accent) / 0.08) 0%, transparent 70%)",
        }}
      />

      {/* Decorative hexagons */}
      <HexLive className="hidden md:block absolute right-[8%] top-24 w-20 h-20"  mode="pulse" baseOpacity={0.15} intervalSec={42} />
      <HexLive className="hidden md:block absolute right-[15%] bottom-12 w-32 h-32" mode="pulse" baseOpacity={0.10} intervalSec={55} />
      <HexLive className="hidden md:block absolute right-[5%] bottom-32 w-12 h-12"  mode="spark" baseOpacity={0.20} intervalSec={32} />
      <HexLive className="hidden md:block absolute left-[3%] bottom-20 w-16 h-16"  mode="spark" baseOpacity={0.12} intervalSec={38} />

      <div className="relative z-10 max-w-7xl w-full mx-auto">

        {/* Badge */}
       {/* <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.05 }}
          className="inline-flex items-center gap-2 bg-accent-soft border border-accent-md
                     text-accent text-xs font-semibold uppercase tracking-widest
                     px-4 py-1.5 rounded-full mb-6"
        >
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent animate-pulse" />
          {t("badge")}
        </motion.div>*/}

        {/* Заголовок */}
                <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-4xl md:text-6xl font-black tracking-tight text-fore mb-16 leading-[1.05] max-w-4xl"
          style={{ textShadow: "0 0 40px rgb(var(--accent) / 0.15)" }}
        >
          {t("h1")}
        </motion.h1>

        {/* Подзаголовок */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-lg md:text-xl text-sec max-w-2xl mb-10 leading-relaxed"
        >
          {t("sub")}
        </motion.p>

        {/* Кнопки */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 items-start sm:items-center"
        >
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => {
              document.getElementById("teams-catalog")?.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="px-8 py-4 bg-accent text-white font-semibold text-base rounded-xl
                       shadow-accent hover:opacity-90 transition-all"
          >
            {t("btn1")}
          </motion.button>

          <Link
            href="/pricing"
            className="px-4 py-4 text-sec font-medium text-base hover:text-fore transition-colors"
          >
            {t("btn2")}
          </Link>
        </motion.div>

        {/* Trust line */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-6 text-sm text-mute"
        >
          {t("trust_sub")}
        </motion.p>

      </div>
    </section>
  );
}